import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { switchMap, timeout, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { ProfileService } from '../../../core/services/profile.service';
import { AuthService } from '../../../core/services/auth.service';
import { MenuService } from '../../../core/services/menu.service';

@Component({
  selector: 'app-redirector',
  standalone: true,
  imports: [CommonModule],
  template: `
  `,
  styles: [
  ]
})
export class RedirectorComponent implements OnInit {
  private router = inject(Router);
  private profileService = inject(ProfileService);
  private authService = inject(AuthService);
  private menuService = inject(MenuService);

  ngOnInit(): void {
    // Check for pending URL redirect first
    if (this.authService.isPendingUrlRedirect()) {
      this.authService.redirectToPendingUrl();
      return;
    }

    // Get start page URL from profile or fall back to default menu URL
    this.profileService.getStartPageRedirectUrl().pipe(
      switchMap(startPageUrl => {
        if (startPageUrl) {
          return of(startPageUrl);
        } else {
          return this.menuService.getDefaultUrl();
        }
      }),
      timeout(3000), // Timeout after 3 seconds to prevent indefinite waiting
      catchError(error => {
        console.error('Failed to get redirect URL:', error);
        return of('/'); // Fallback to root on error or timeout
      })
    ).subscribe(url => {
      this.router.navigateByUrl(this.router.parseUrl(url as string));
    });
  }
}
